// for timezone formats, this is a php to moment mapping
export const PHP_TO_MOMENT: Record<string, string> = {
    // Year
    Y: 'YYYY', y: 'YY',
    // Month
    F: 'MMMM', M: 'MMM', m: 'MM', n: 'M',
    // Day of Month
    d: 'DD', j: 'D',
    // Day of Week
    l: 'dddd', D: 'ddd', w: 'd',
    // Hour
    H: 'HH', G: 'H', h: 'hh', g: 'h',
    // Minute
    i: 'mm',
    // Second
    s: 'ss',
    // AM / PM
    A: 'A', a: 'a',
    // Timezone / Full ISO
    O: 'ZZ', P: 'Z', c: 'YYYY-MM-DDTHH:mm:ssZ'
};

export function convertPhpDateFormatToMoment(phpFormat: string): string {
    // 1. Rule-based check: Does it look like it's already a Moment format?
    // Moment uses multi-character tokens like YYYY, DD, MM, HH.
    // PHP uses single letters like Y, d, m, H.
    const isAlreadyMoment = /(YYYY|YY|MMMM|MMM|MM|DDDD|DD|dddd|ddd|dd|HH|mm|ss)/.test(phpFormat);

    // If it already matches common Moment patterns, return it as-is
    if (isAlreadyMoment) {
        return phpFormat;
    }

    // 3. Regex token matching.
    // This loops through each character, respecting escaped PHP characters (like \a)
    return phpFormat.replace(/\\?([a-zA-Z])/g, (match, token) => {
        // If the character was escaped in PHP (e.g., "\d"), remove the backslash
        if (match.startsWith('\\')) {
            return token;
        }
        // If the token exists in our map, swap it. Otherwise, keep it.
        return PHP_TO_MOMENT[token] !== undefined ? PHP_TO_MOMENT[token] : token;
    });
}
